var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_42",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55909",
    "data-name": "Group 55909",
    transform: "translate(8.641 -0.393)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.64, 0.39)",
    filter: "url(#Ellipse_42)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42-2",
    "data-name": "Ellipse 42",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(9 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55908",
    "data-name": "Group 55908",
    transform: "translate(11.684 15.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87668",
    "data-name": "Path 87668",
    d: "M155.669,325.91a1.28,1.28,0,0,1-.9-.372,10.44,10.44,0,0,0-14.423,0,1.275,1.275,0,0,1-1.8-1.8,12.744,12.744,0,0,1,18.028,0,1.276,1.276,0,0,1,0,1.8A1.259,1.259,0,0,1,155.669,325.91Z",
    transform: "translate(-136.202 -308.817)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 3,
    cy: 1.5,
    rx: 3,
    ry: 1.5,
    transform: "translate(-0.325 0.46)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 3.5,
    cy: 1.5,
    rx: 3.5,
    ry: 1.5,
    transform: "translate(13.675 0.46)",
    fill: "#444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.aa6ee3bd1a7caf3cdcdd0ac0910e13bc.svg";
export { ForwardRef as ReactComponent };